/**
 * Created by emanuele on 31/01/2017.
 */
import React, {Component} from 'react';

class PrintButton extends Component {
    render(){
        let title = this.props.title ? this.props.title : 'PDF'
        return <a href="#" onClick={(ev) => (this.props.onClick(ev))}>
            <div className="ui left floated small primary labeled icon button">
                <i className="file pdf outline icon"></i> {title}
            </div>
        </a>
    }
}

export default PrintButton;


/** WEBPACK FOOTER **
 ** ./src/components/PdfButton.jsx
 **/